import { Notebook, Send, Timer } from "lucide-react";
import React, { useState, useMemo } from "react";

// API QuickLink interface
interface ApiQuickLink {
  id?: string;
  name: string;
  value: string;
  type: 'url' | 'application';
  icon: string | null;
  description?: string | null;
  is_visible?: boolean;
  is_favorite?: boolean;
  team_id?: string | number | null;
  user_id?: string | number | null;
  order?: number;
  created_at?: string;
  updated_at?: string;
}

interface QuickLinksResponse {
  all: ApiQuickLink[];
  grouped: {
    team_id: string | number | null;
    team_name: string;
    links: ApiQuickLink[];
  }[];
  favorites: ApiQuickLink[];
}

// Frontend display interface
interface DisplayQuickLink {
  title: string;
  url: string;
  icon: string;
}

interface QuickActionsProps {
  quickLinks?: QuickLinksResponse;
  onShowNotesOverlay: () => void;
  onShowPomodoroSetup: () => void;
  onShowFileTransfer: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({ 
  quickLinks, 
  onShowNotesOverlay, 
  onShowPomodoroSetup,
  onShowFileTransfer
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  

  return (
    <div className="flex justify-left relative">
        {/* Main Pill Container */}
        <div className="flex items-center bg-background dark:bg-background rounded-full px-[0.3rem] py-[0.25rem]">
          {/* Quick Action Buttons */}
          <div className="flex items-center group">
            <button 
              onClick={onShowNotesOverlay}
              className="flex items-center justify-center w-10 h-10 hover:bg-secondary/50 dark:hover:bg-secondary/50 rounded-full transition-all duration-200 group overflow-hidden"
            >
              <Notebook className="w-4 h-4 text-gray-600 dark:text-gray-300 group-hover:text-primary" />
            </button>
            <div className="absolute bottom-0 left-0 transform translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-2 py-1 rounded text-xs whitespace-nowrap">
              Notities openen
            </div>
          </div>

          {/* Pomodoro Timer Button */}
          <div className="flex items-center group">
            <button 
              onClick={onShowPomodoroSetup}
              className="flex items-center justify-center w-10 h-10 hover:bg-secondary/50 dark:hover:bg-secondary/50 rounded-full transition-all duration-200 group overflow-hidden"
            >
              <Timer className="w-4 h-4 text-gray-600 dark:text-gray-300 group-hover:text-primary" />
            </button>
             <div className="absolute bottom-0 left-0 transform translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-2 py-1 rounded text-xs whitespace-nowrap">
            Pomodoro timer starten
            </div>
          </div>

          {/* File Transfer Button */}
          <div className="flex items-center group">
            <button 
              onClick={onShowFileTransfer}
              className="flex items-center justify-center w-10 h-10 hover:bg-secondary/50 dark:hover:bg-secondary/50 rounded-full transition-all duration-200 group overflow-hidden"
            >
              <Send className="w-4 h-4 text-gray-600 dark:text-gray-300 group-hover:text-primary" />
            </button>
           <div className="absolute bottom-0 left-0 transform translate-y-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-2 py-1 rounded text-xs whitespace-nowrap">
              Bestand overdragen
            </div>
        
        </div>

        {/* Click outside to close dropdown */}
        {isDropdownOpen && (
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsDropdownOpen(false)}
          ></div>
        )}
      </div>
    </div>
  );
};

export default QuickActions; 